import React, { useEffect, useRef } from "react";
import {
  DataSet,
  Network as Net,
} from "vis-network/standalone/esm/vis-network";
import { NodeType } from "../neat/node";

import Network from "../neat/network";

interface NetworkVisProps {
  network: Network;
}

const NetworkVis = ({ network }: NetworkVisProps) => {
  const domNode = useRef<HTMLDivElement>(null);
  const net = useRef<Net | null>(null);

  function typeToColor(type: NodeType) {
    switch (type) {
      case "input":
        return "#51cf66";
      case "output":
        return "#fcc419";
      case "hidden":
        return "#339af0";
    }
  }

  function typeToLevel(type: NodeType) {
    switch (type) {
      case "input":
        return 0;
      case "output":
        return 2;
      case "hidden":
        return 1;
    }
  }

  useEffect(() => {
    const nodes = new DataSet(
      network.sortedNodes.map((node) => ({
        id: node.number,
        label: node.number,
        color: typeToColor(node.type),
        level: typeToLevel(node.type),
      }))
    );
    const edges = new DataSet(
      network.connections
        .filter((conn) => conn.enabled)
        .map((conn) => ({
          from: conn.from.number,
          to: conn.to.number,
          color: "#495057",
          value: conn.weight,
        }))
    );
    const data = {
      nodes,
      edges,
    };

    const options = {
      width: "300",
      height: "300",
      layout: {
        hierarchical: {
          direction: "LR",
          sortMethod: "directed",
        },
      },
      edges: {
        smooth: true,
        arrows: { to: true },
      },
      interaction: {
        dragNodes: false,
        dragView: false,
        zoomView: false,
      },
    };

    net.current = new Net(domNode.current!, data, options);
  }, [domNode, net, network]);

  return <div ref={domNode} />;
};

export default NetworkVis;
